import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDot } from '@fortawesome/free-solid-svg-icons';
import { RadioGroup } from '@progress/kendo-react-inputs';
import type { FieldTypeDefinition, FieldRendererProps } from '../registry';
import { OptionsEditor } from '../shared/OptionsEditor';

/** Stores the option's scoring weight when present, otherwise its raw value — see RadioField/LikertScaleField. */
function answerForOption(opt: { value: string; weight?: number }): string | number {
  return typeof opt.weight === 'number' ? opt.weight : opt.value;
}

function RadioRenderer({ field, value, onChange, readOnly }: FieldRendererProps) {
  const options = field.options ?? [];
  const data = options.map((o) => ({ label: o.label, value: answerForOption(o) }));
  const radioValue = typeof value === 'string' || typeof value === 'number' ? value : null;
  return (
    <RadioGroup
      data={data}
      value={radioValue}
      onChange={(e) => onChange(e.value ?? null)}
      disabled={readOnly}
    />
  );
}

export const definition: FieldTypeDefinition = {
  key: 'RDO',
  label: 'Radio Group',
  category: 'choice',
  icon: <FontAwesomeIcon icon={faCircleDot} fixedWidth />,
  defaultProps: {
    label: 'New radio group',
    isRequired: false,
    options: [
      { id: 'o1', value: 'yes', label: 'Yes', order: 0 },
      { id: 'o2', value: 'no', label: 'No', order: 1 },
    ],
  },
  Renderer: RadioRenderer,
  PropertyEditor: OptionsEditor,
};
